(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["peptea-hero"] && !Shopify.designMode) return;
  try {
    
  /**
   * <peptea-hero-media>
   * Swaps the poster image for a muted, looping, inline video when:
   *  - a video exists for the current viewport (mobile video on <750px, desktop otherwise;
   *    the desktop video is reused on mobile when no mobile video is set),
   *  - the visitor does not prefer reduced motion and has not enabled data saver.
   * Pauses the video while the hero is off screen. No external dependencies.
   */
  if (!customElements.get('peptea-hero-media')) {
    class PepteaHeroMedia extends HTMLElement {
      connectedCallback() {
        this.mobileQuery = window.matchMedia('(max-width: 749px)');
        this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.onChange = () => this.update();
        this.mobileQuery.addEventListener('change', this.onChange);
        this.motionQuery.addEventListener('change', this.onChange);
        this.update();
      }

      disconnectedCallback() {
        this.mobileQuery?.removeEventListener('change', this.onChange);
        this.motionQuery?.removeEventListener('change', this.onChange);
        this.observer?.disconnect();
      }

      pickTemplate() {
        const mobile = this.querySelector('template[data-peptea-video="mobile"]');
        const desktop = this.querySelector('template[data-peptea-video="desktop"]');
        return this.mobileQuery.matches ? mobile || desktop : desktop;
      }

      update() {
        const saveData = navigator.connection && navigator.connection.saveData;
        const template = this.motionQuery.matches || saveData ? null : this.pickTemplate();
        const key = template ? template.dataset.pepteaVideo : null;
        if (key === this.currentKey) return;

        this.currentKey = key;
        this.video?.remove();
        this.video = null;
        this.observer?.disconnect();
        this.classList.remove('is-playing');
        if (!template) return;

        const video = template.content.querySelector('video')?.cloneNode(true);
        if (!video) return;
        video.muted = true;
        video.defaultMuted = true;
        video.playsInline = true;
        video.loop = true;
        video.controls = false;
        video.setAttribute('aria-hidden', 'true');
        video.setAttribute('tabindex', '-1');
        video.addEventListener('playing', () => this.classList.add('is-playing'), { once: true });
        this.append(video);
        this.video = video;

        this.observer = new IntersectionObserver((entries) => {
          for (const entry of entries) {
            if (entry.isIntersecting) video.play().catch(() => {});
            else video.pause();
          }
        });
        this.observer.observe(this);
      }
    }
    customElements.define('peptea-hero-media', PepteaHeroMedia);
  }

  } catch(e) { console.error(e); }
})();
})();
